import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";

import Time from "../components/time";
import Swal from "sweetalert2";
import { useNavigate, Link } from "react-router-dom";

const Battery_card_entry = () => {
  useAuthRedirect();

  const navigate = useNavigate();

  const [vehicles, setVehicles] = useState([]);
  const [batteryCode, setBatteryCode] = useState([]);
  const [batteryType, setBatteryType] = useState([]);
    const [expectLife, setExpectLife] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(localStorage.getItem("branch") || "");
  const [formData, setFormData] = useState({
    vehicle: "",
    batteryCode: "",
    batteryType: "",
    life: "",
    fittedKm: "",
    fittedDate: "",
  });


   
            const canEntry = hasPermission("Battery Card Maintenance", "entry");
   
       

  useEffect(() => {
    fetchBatteryCode();
    fetchBatteryType();
    fetchExpectLife();
  }, []);

  const fetchBatteryCode = async () => {
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/battery_code");
      setBatteryCode(response.data.batteryCode);
    } catch (error) {
      console.error("Error fetching locations:", error);
    }
  };


  const fetchBatteryType = async () => {
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/battery_type");
      setBatteryType(response.data.batteryType);
    } catch (error) {
      console.error("Error fetching locations:", error);
    }
  };

  const fetchExpectLife = async () => {
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/expected_period");
      setExpectLife(response.data.expectedPeriod);
    } catch (error) {
      console.error("Error fetching locations:", error);
    }
  };

  useEffect(() => {
    const fetchVehicles = async () => {
      if (!selectedBranch) return;
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/battery_vehicle?branch_code=${selectedBranch}`
        );
        setVehicles(response.data.vehicles || []);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchVehicles();
  }, [selectedBranch]);

  // Handle Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  // ✅ Validations
  if (!formData.vehicle || formData.vehicle.trim() === "") {
    Swal.fire({
      icon: "warning",
      title: "Missing Field",
      text: "Please select Vehicle.",
    });
    return;
  }

  if (!formData.batteryCode || formData.batteryCode.trim() === "") {
    Swal.fire({
      icon: "warning",
      title: "Missing Field",
      text: "Please select Battery Code.",
    });
    return;
  }

  if (!formData.batteryType || formData.batteryType.trim() === "") {
    Swal.fire({
      icon: "warning",
      title: "Missing Field",
      text: "Please select Battery Type.",
    });
    return;
  }

  if (!formData.life || formData.life.trim() === "") {
    Swal.fire({
      icon: "warning",
      title: "Missing Field",
      text: "Please enter Battery Life.",
    });
    return;
  }

  if (!formData.fittedKm || isNaN(formData.fittedKm) || Number(formData.fittedKm) <= 0) {
    Swal.fire({
      icon: "warning",
      title: "Invalid Input",
      text: "Fitted KM/Hr must be a positive number and not zero.",
    });
    return;
  }

  if (!formData.fittedDate) {
    Swal.fire({
      icon: "warning",
      title: "Missing Field",
      text: "Please select Fitted Date.",
    });
    return;
  }

  // ✅ If validation passes, prepare payload
  const payload = {
    vehicle: formData.vehicle,
    batteryCode: formData.batteryCode,
    batteryType: formData.batteryType,
    life: formData.life,
    fittedKm: formData.fittedKm,
    fittedDate: formData.fittedDate,
  };

  console.log("Submitting Payload:", payload);

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.post(
      "https://rfs2.infraconsoft.net.in/api/battery_insert",
      payload
    );

    console.log(response);

    Swal.fire({
      title: "Success!",
      text: "Battery Card added successfully.",
      icon: "success",
      width: "500px",
      height: "40vh",
      draggable: true,
    }).then(() => {
      navigate(`/battery_transaction_view`);
    });

  } catch (error) {
    console.error("Error submitting form:", error);
    Swal.fire({
      icon: "error",
      title: "Insert Failed",
      text: "Submission failed. Please try again.",
    });
  }
};


  if (!canEntry) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
        <div className="back-div">
          <h2 className="add-txt">Add Battery Transaction</h2>
          <Link to='/battery_transaction_view'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
        </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle :</label>
                <select
                  name="vehicle"
                  value={formData.vehicle}
                  onChange={handleChange}
                >
                  <option value="">-- Select Vehicle --</option>
                  {vehicles.map((row, index) => (
                    <option key={index} value={row.vehicle_name}>
                      {row.vehicle_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Battery Code :</label>
                <select
                  name="batteryCode"
                  value={formData.batteryCode}
                  onChange={handleChange}
                >
                  <option value="">-- Select Battery code --</option>
                  {batteryCode.map((location, index) => (
                    <option key={index} value={location.battery_code}>
                      {location.battery_code}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>Battery type :</label>
                <select
                  name="batteryType"
                  value={formData.batteryType}
                  onChange={handleChange}
                >
                  <option value="">-- Select type --</option>
                  {batteryType.map((location, index) => (
                    <option key={index} value={location.battery_type}>
                      {location.battery_type}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Expected Period :</label>
                <select
                  name="life"
                  value={formData.life}
                  onChange={handleChange}
                >
                  <option value="">-- Select Expected Period --</option>
                  {expectLife.map((location, index) => (
                    <option key={index} value={location.life}>
                      {location.life}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Fitted Km/Hr :</label>
                <input
                  type="text"
                  name="fittedKm"
                  value={formData.fittedKm}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Fitted Date :</label>
                <input
                  type="date"
                  name="fittedDate"
                  value={formData.fittedDate}
                  onChange={handleChange}
                />
              </div>
            </div>

            

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Battery_card_entry;
